import { useState } from "react";
import { AddVariablesDetail } from "../../../api/variablesController";
import { READ_ONLY_VARIABLE_NAME } from "../../../common/constants";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	Grid,
	TextField,
	Tooltip,
} from "../../../common/MaterialComponent";
import Shared from "../../../common/shared";
import { ButtonPrimary } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface AddButtonProps {
	countryId: number;
	setVariablesUpdated: (flag: boolean) => void;
}

export const AddButton: React.FC<AddButtonProps> = ({
	countryId,
	setVariablesUpdated,
}) => {
	const [addDialogOpen, setAddDialog] = useState(false);
	const [name, setName] = useState("");
	const [value, setValue] = useState("");
	const [group, setGroup] = useState("");
	const [addDisabled, setAddDisabled] = useState(true);

	const strings = useGetComponentStringsContext().AddVariableButton;

	const handleNameChange = (event: any) => {
		setName(event.target.value);
		if (
			event.target.value === "" ||
			value.trim() === "" ||
			event.target.value.includes(" ") ||
			group.trim() === READ_ONLY_VARIABLE_NAME
		) {
			setAddDisabled(true);
		} else {
			setAddDisabled(false);
		}
	};
	const handleValueChange = (event: any) => {
		setValue(event.target.value);
		if (
			name === "" ||
			event.target.value.trim() === "" ||
			name.includes(" ") ||
			group.trim() === READ_ONLY_VARIABLE_NAME
		) {
			setAddDisabled(true);
		} else {
			setAddDisabled(false);
		}
	};
	const handleGroupChange = (event: any) => {
		setGroup(event.target.value);
		if (
			name === "" ||
			value.trim() === "" ||
			name.includes(" ") ||
			event.target.value.trim() === READ_ONLY_VARIABLE_NAME
		) {
			setAddDisabled(true);
		} else {
			setAddDisabled(false);
		}
	};

	const addVariable = async () => {
		let addGroup;
		if (group.trim() === "") {
			addGroup = null;
		} else {
			addGroup = group.trim();
		}

		try {
			const res = await AddVariablesDetail({
				Name: name,
				Value: value.trim(),
				CountryId: countryId,
				Group: addGroup,
			});
			setAddDialog(false);
			setName("");
			setValue("");
			setGroup("");
			setAddDisabled(true);

			if (res.error) {
				Shared.showSnackbarMessage("Failed to add variable");
			} else {
				Shared.showSnackbarMessage("Successfully added variable");
				setVariablesUpdated(true);
			}
		} catch (err) {
			console.error(err);
		}
	};

	return (
		<>
			<Dialog open={addDialogOpen}>
				<DialogTitle>{strings.addDialogTitle}</DialogTitle>
				<DialogContent>
					<Grid container>
						<Grid item xs={3}>
							<TextField
								label={strings.addDialogName}
								value={name}
								onChange={handleNameChange}
								disabled={false}
								error={name.includes(" ")}
								helperText={name.includes(" ") ? "Spaces not allowed" : ""}
							/>
						</Grid>
						<Grid item xs={1} />
						<Grid item xs={3}>
							<TextField
								label={strings.addDialogValue}
								value={value}
								onChange={handleValueChange}
								disabled={false}
								multiline
							/>
						</Grid>
						<Grid item xs={1} />
						<Grid item xs={3}>
							<TextField
								label={strings.addDialogGroup}
								value={group}
								onChange={handleGroupChange}
								disabled={false}
							/>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<ButtonPrimary
						onClick={() => {
							//reset values
							setName("");
							setValue("");
							setGroup("");
							setAddDialog(false);
							setAddDisabled(true);
						}}
						autoFocus
					>
						{strings.cancelText}
					</ButtonPrimary>
					<ButtonPrimary disabled={addDisabled} onClick={addVariable}>
						{strings.addDialogConfirm}
					</ButtonPrimary>
				</DialogActions>
			</Dialog>

			<Tooltip title={strings.addVariableTooltip}>
				<ButtonPrimary
					onClick={() => setAddDialog(true)}
					className="addTemplateBtn"
				>
					<Icon>add</Icon>
				</ButtonPrimary>
			</Tooltip>
		</>
	);
};
